export const placeStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
  WAITING_DETAILS: 'WAITING_DETAILS',
}
